import { Skeleton } from "../../../../core/ui";

export const SearchResultsSkeleton = ({ items = 5 }: { items?: number }) => {
  const results = [];
  for (let idx = 0; idx < items; idx++) {
    results.push(
      <div className="component-coast-search-item" key={idx}>
        <figure className="item-thumb">
          <Skeleton pulse={true} type="image" name="card thumbnail" shape="16x9" />
        </figure>

        <div className="item-title">
          <Skeleton pulse={true} type="text" name="item title" size={5} />
        </div>

        <div className="item-meta">
          <Skeleton pulse={true} type="text" name="item meta" size={6} width="40%" />
        </div>

        <div className="item-summary">
          <Skeleton pulse={true} type="text" name="item summary" size={6} height="10rem" />
        </div>
      </div>,
    );
  }

  return <section className="search-items">{results}</section>;
};
